/* Cortazu (speed sweep 27 Oct 2026): lazy sections on the PDP. Cortazu file, not part of Hyper.
   Heavy below-the-fold sections ("Pairs well with" = sections/cz-pdp-pairs.liquid, "Compare" =
   sections/cz-pdp-v2-compare.liquid) render a light placeholder in the page and their real content through the Section
   Rendering API (<product url>?section_id=<section file name>) once the placeholder comes within ~1500px of the screen,
   when a link to it is followed (sub-navigation, #hash), or on idle after 6 s.
   Placeholder: [data-cz-lazy-src] (URL), data-cz-lazy-pick (selector in the response), data-cz-lazy-into (selector
   inside the placeholder, default = the placeholder), data-cz-lazy-mode "inner" (default) or "outer".
   After the swap: event "cz:lazy-loaded" (bubbles, detail.empty = nothing came back).
   29 Oct 2026 (CLS 0.30-0.32 on the Alpine PDP with a fast scroll, same approach as B1 in cz-coll-more.js): the
   placeholder reserves a measured height. After every swap the real height is stored per breakpoint (localStorage
   "czLazyH", per URL and per pick selector) and used for the next placeholder; until then the per-breakpoint estimate
   from the section's CSS applies. When the swap happens while the placeholder is on screen and the content is shorter,
   the reserved height stays until the block has left the screen (released off screen = no visible shift; above the
   screen the browser's scroll anchoring keeps the view still). */
(function () {
  if (window.czLazy) return;
  var d = document;
  var KEY = 'czLazyH';

  function bp() { var w = window.innerWidth || d.documentElement.clientWidth; return w < 750 ? 'm' : (w < 990 ? 't' : 'd'); }
  function store() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
  function keys(el) {
    var src = (el.dataset.czLazySrc || '').split('#')[0];
    return [bp() + '|' + src, bp() + '|' + (el.dataset.czLazyPick || '*')];
  }
  function remember(el, h) {
    if (!(h > 0)) return;
    try {
      var s = store(), k = keys(el);
      s[k[0]] = h; s[k[1]] = h;
      var all = Object.keys(s);
      if (all.length > 60) all.slice(0, all.length - 60).forEach(function (x) { delete s[x]; });
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) { /* storage blocked: the CSS estimate stays */ }
  }
  function reserve(el) {
    // 3 Nov 2026 (F4): Hyper's theme.css hides every empty div (div:empty:not(.no-empty) { display: none }), so the empty
    // placeholder had no height (the reservation never applied) and never intersected (it only loaded on the 6 s idle
    // prefetch, often after the shopper had passed it: CLS 1.0 at 375 px). .no-empty is Hyper's own opt-out.
    el.classList.add('no-empty');
    if (el.dataset.czLazyState) return;
    var s = store(), k = keys(el), h = s[k[0]] || s[k[1]];
    if (h > 0) el.style.minHeight = Math.round(h) + 'px';
  }
  function onScreen(r) { return r.bottom > 0 && r.top < (window.innerHeight || d.documentElement.clientHeight); }
  // run fn once el no longer touches the screen
  function whenOff(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (en) {
      if (!en[en.length - 1].isIntersecting) { io.disconnect(); fn(); }
    });
    io.observe(el);
  }

  function load(el) {
    if (!el || el.dataset.czLazyState) return;
    el.dataset.czLazyState = 'loading';
    fetch(el.dataset.czLazySrc, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var src = null;
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          src = doc.querySelector(el.dataset.czLazyPick || 'body > *');
        }
        var into = (el.dataset.czLazyInto && el.querySelector(el.dataset.czLazyInto)) || el;
        var r0 = el.getBoundingClientRect(); // reserved box, before the swap
        if (src) into.innerHTML = el.dataset.czLazyMode === 'outer' ? src.outerHTML : src.innerHTML;
        el.dataset.czLazyState = 'done';
        el.removeAttribute('aria-busy');
        el.style.minHeight = ''; // natural height (a CSS estimate should target [aria-busy], gone once done)
        var h = src ? el.offsetHeight : 0; // forced layout in the same task: nothing is painted in between
        if (src) remember(el, h);
        if (src && h < r0.height - 1 && onScreen(r0)) {
          // shorter than reserved and on screen: keep the reserved height until the block is off screen
          el.style.minHeight = Math.round(r0.height) + 'px';
          whenOff(el, function () {
            // r71 (29 Oct): released above the screen on mobile, scroll anchoring did not always correct it (CLS 0.72
            // on Alpine 390) -> correct the scroll ourselves when the browser did not
            var rb = el.getBoundingClientRect(), y0 = window.pageYOffset;
            el.style.minHeight = '';
            if (rb.bottom <= 0) {
              var diff = rb.height - el.getBoundingClientRect().height;
              if (diff > 1 && Math.abs(window.pageYOffset - y0) < 1) window.scrollBy(0, -diff);
            }
          });
        }
        // 27 Oct (r54): nothing came back (e.g. fewer than 2 comparable styles) -> no empty band: hide the placeholder,
        // and its section when nothing else in it is visible.
        if (!src) {
          el.hidden = true;
          var sec = el.closest('.shopify-section');
          if (sec && !sec.querySelector(':scope > :not(script):not(style):not(link):not([hidden])')) sec.hidden = true;
        }
        el.dispatchEvent(new CustomEvent('cz:lazy-loaded', { bubbles: true, detail: { empty: !src } }));
      })
      .catch(function () { el.dataset.czLazyState = ''; });
  }

  function all() { return [].slice.call(d.querySelectorAll('[data-cz-lazy-src]')); }

  function start() {
    var els = all();
    if (!els.length) return;
    els.forEach(reserve);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); load(en.target); } });
      }, { rootMargin: '1500px 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(load);
    }
    // a followed link (#compare, sub-navigation) or a hash on arrival loads everything
    function loadAll() { all().forEach(load); }
    if (location.hash) loadAll();
    window.addEventListener('hashchange', loadAll);
    d.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="#"]');
      if (a && a.closest('[data-cz-pnav]')) loadAll();
    }, true);
    // idle prefetch so the content is there before a fast scroll
    setTimeout(function () {
      (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(loadAll);
    }, 6000);
  }

  window.czLazy = { load: load };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})();
